// Words that don't have plural forms (case-insensitive)
const NON_PLURALIZABLE_WORDS = new Set(["naics"]);

export const pluralize = (word: string, count = 2) => {
  if (count === 1) return word;

  // Check if word should not be pluralized
  if (NON_PLURALIZABLE_WORDS.has(word.toLowerCase())) {
    return word;
  }

  // Words ending in s, x, z, ch, sh
  if (/s$|x$|z$|ch$|sh$/i.test(word)) return `${word}es`;

  // Words ending in y
  if (/y$/i.test(word) && !/[aeiou]y$/i.test(word))
    return `${word.slice(0, -1)}ies`;

  // Default
  return `${word}s`;
};

export const singularize = (word: string) => {
  // Words ending in "ies" (from "y" pluralization rule)
  if (/[^aeiou]ies$/i.test(word)) return word.slice(0, -3) + "y";

  // Words ending in "es" from special rules (boxes -> box, churches -> church)
  if (/([sxz]|ch|sh)es$/i.test(word)) return word.slice(0, -2);

  // Regular plural words ending in "s"
  if (/[^s]s$/i.test(word)) return word.slice(0, -1);

  // Irregular plurals or already singular words
  return word;
};

export const formatCountLabel = (
  label: string,
  count: number,
  noPrefix = false
) => {
  const singularizedLabel = singularize(label);
  const pluralizedLabel = pluralize(label);

  if (count === 0)
    return noPrefix ? pluralizedLabel : `Select ${pluralizedLabel}`;
  if (count === 1) return `1 ${singularizedLabel.toLowerCase()}`;

  return `${count} ${pluralizedLabel.toLowerCase()}`;
};
